import {Platform, StatusBar} from "react-native";
import {activateKeepAwakeAsync} from "expo-keep-awake";
import * as ScreenOrientation from "expo-screen-orientation";
import {deviceLeds} from "../deviceLeds";
import * as NavigationBar from "expo-navigation-bar";
import {isAndroid, isWEB} from "../helpers/getPlatformType";
import {STORAGE} from "../storage";

export const setDeviceSettings = async () => {
    // device specific settings initialization
    StatusBar.setHidden(true) // Hide the status bar

    await activateKeepAwakeAsync(); // Keep the device awake

    if (!isWEB()) {
        await ScreenOrientation.unlockAsync(); // Unlock the screen orientation
    }

    const prodvxtoken = await STORAGE.get('prodvx_token')

    await deviceLeds('off', null, prodvxtoken) // Turn off the device lights - if applicable

    if (isAndroid()) await NavigationBar.setVisibilityAsync("hidden"); // Hide the navigation bar - Android only
}